export default {"src":"/_next/static/media/sue.923c8eb8.svg","height":176,"width":197};